import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const STORAGE_KEY = "affiliate_ref";

/**
 * Reads `?ref=` from the URL and persists it in sessionStorage.
 * Returns the active ref username (URL param takes priority, then stored value).
 */
export function useAffiliateRef(): string {
  const [searchParams] = useSearchParams();
  const urlRef = searchParams.get("ref") || "";

  useEffect(() => {
    if (urlRef) {
      sessionStorage.setItem(STORAGE_KEY, urlRef);
    }
  }, [urlRef]);

  return urlRef || sessionStorage.getItem(STORAGE_KEY) || "";
}
